<template>
    <vue-modal :isShowModal="isLogModal" @close="$emit('close')" :style="'height: fit-content; width: 40rem;'">
        
        <template #header>Log</template>
        <template #body>
            <div v-if="logs.length > 0"
                v-for="log in logs"
                style="margin-bottom: 10px;">
                <span>
                    {{ format(new Date(log.created_at), "d. MMMM yyyy") }}, kl. {{ format(new Date(log.created_at), "HH.mm") }}:
                    Journalnotatet er {{ log.action == 'create' ? 'oprettet'
                                        : log.action == 'update' ? 'redigeret'
                                        : 'kommenteret på' }} af {{ log.userName }}
                </span>
            </div>
            <div v-else>
                <span>Der er ingen logs på dette journal notat</span>
            </div>
        </template>
    </vue-modal>
</template>
<script setup>
import vueModal from "@elements/form/vueModal.vue";
import { setDefaultOptions, format } from "date-fns";
import da from "date-fns/locale/da";

setDefaultOptions({ locale: da });

const emit = defineEmits(['close']);
const props = defineProps({
    isLogModal: Boolean,
    logs: Array,
});

console.log(props.users);

</script>